module.exports = {"gameCode":"XXXXXX","totalSeasons":2,"totalRaces":2,"currentSeason":1,"currentRace":1,"phase":"INTRO","remainingSeconds":0,"players":[{"id":"XXXXXX-1"},{"id":"XXXXXX-2"},{"id":"XXXXXX-3"},{"id":"XXXXXX-4"}],"logs":[]}


//////////////////
// WEBPACK FOOTER
// ./src/data/mocks/mc/game.json
// module id = ./src/data/mocks/mc/game.json
// module chunks = 0